import { debounce, get } from "lodash";
import { useEffect } from "react";
import { getIndicatorName } from "~/libs/getData";
import { useTranslation } from "react-i18next";

import { useGetIndicatorsForSelectLazyQuery } from "~/schemas/generated/graphql";

export const onScrollBottomIndicator = () => {
  const { t } = useTranslation();
  const [GetIndicatorsForSelectQuery, { data, loading, fetchMore }] =
    useGetIndicatorsForSelectLazyQuery({
      variables: {
        page: 0,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    GetIndicatorsForSelectQuery();
  }, []);

  const indicatorsForSelect = [
    {
      value: null,
      label: t("common.without_indicator"),
    },
    ...get(data, "IndicatorGetter.getIndicators.items", []).map(
      ({ id, ...ind }) => {
        const label = getIndicatorName(ind);
        return {
          value: id,
          label: `(${id}) ${label}`,
        };
      }
    ),
  ];

  const onScrollBottomIndicators = () => {
    fetchMore({
      variables: {
        page: Math.ceil(indicatorsForSelect.length / 25),
      },
      updateQuery: ({ IndicatorGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) return { IndicatorGetter };
        return {
          IndicatorGetter: {
            ...IndicatorGetter,
            getIndicators: {
              ...IndicatorGetter.getIndicators,
              items: [
                ...IndicatorGetter.getIndicators.items,
                ...get(
                  fetchMoreResult,
                  "IndicatorGetter.getIndicators.items",
                  []
                ),
              ],
            },
          },
        };
      },
    });
  };

  const searchIndicator = debounce((searchText) => {
    GetIndicatorsForSelectQuery({
      variables: {
        page: 0,
        searchField: searchText.length > 0 ? "nameOrId" : "",
        searchText,
      },
    });
  });

  return {
    onScrollBottomIndicators,
    indicatorsForSelect,
    searchIndicator,
    loading,
  };
};
